// import Vue from "vue"
function onScroll(e) {
  const bottom = e.target.scrollHeight - e.target.scrollTop - 5 <= e.target.clientHeight;
  if (bottom && binding.value) {

    binding.value(e); // 调用传入的回调函数
  }
}
let binding = ''
const scrollBottom = {
  bind(el, b) {
    binding = b
    el.addEventListener('scroll', onScroll);
  },
  unbind(el) {
    el.removeEventListener('scroll', onScroll); // 注意：这里的 onScroll 需要提升为外部变量或直接在解绑时重新定义，否则会报错。通常的做法是提升为外部变量。
  }
}
export { scrollBottom }